/** @jsx h */
import { labels } from '../config';
import Pagination from './Pagination';
import CalendarItem from './CalendarItem';

const CalendarList = ({
  list,
  pagination,
  loadMore,
  pluginNamespace,
  allResultCount,
}) => {
  function handleLoadMoreClick() {
    loadMore();
  }

  return (
    <section className="teaser-list">
      <header className="sr-only teaser-list__header">
        <h2 aria-live="polite">
          {allResultCount === 1
            ? labels.results.foundSingular
            : labels.results.found.replace('@resultsTotal', allResultCount)}
        </h2>
      </header>
      <ul className="teaser-list__list">
        {list &&
          list.map(result => (
            <CalendarItem result={result} key={`${result.type}-${result.id}`} />
          ))}
      </ul>
      <Pagination
        pagination={pagination}
        triggerLoadMore={handleLoadMoreClick}
        pluginNamespace={pluginNamespace}
      />
    </section>
  );
};

export default CalendarList;
